import { type SidePanelContent } from '@/ui/layout/side-panel/types/SidePanelContent';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Kept after closing so the content slides out with the panel instead of
// disappearing first.
export const sidePanelContentState = createAtomState<SidePanelContent | null>({
  key: 'sidePanelContentState',
  defaultValue: null,
});
